import { render, staticRenderFns } from "./complainList.vue?vue&type=template&id=3cc281ee&scoped=true"
import script from "./complainList.vue?vue&type=script&lang=js"
export * from "./complainList.vue?vue&type=script&lang=js"
import style0 from "./complainList.vue?vue&type=style&index=0&id=3cc281ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc281ee",
  null
  
)

export default component.exports